let promise = null;

function injectScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

function injectStyle(href) {
  if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();
  return new Promise((resolve) => {
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.onload = resolve;
    document.head.appendChild(l);
  });
}

export function loadFroala() {
  if (promise) return promise;
  promise = (async () => {
    await injectScript('/froala/jquery.min.js');
    await injectScript('/froala/froala_editor.pkgd.min.js');
    await injectScript('/froala/ru.js');
    await Promise.all([
      injectStyle('/froala/froala_editor.pkgd.min.css'),
      injectStyle('/froala/froala_style.min.css'),
    ]);
    await Promise.all([
      import('./plugins/morePlugin'),
      import('./plugins/offtopPlugin'),
      import('./plugins/quoteBracketsPlugin'),
    ]);
  })();
  return promise;
}
